// extracted by mini-css-extract-plugin
export var contrastLow = "_3s-1";
export var externalLink = "_3s-2";
export var externalLinkIcon = "_3s-3";
export var link = "_3s-0";
export var linkLabel = "_3s-4";